/* eslint-disable no-param-reassign,no-unused-vars */
import Vue from 'vue'

const HelperPlugin = {
  install(/* vue */) {
    Vue.mixin({
      methods: {
        $offerRequestSent() {
          try {
            if (process.env.NODE_ENV === 'development') {
              console.log('$offerRequestSent');
              return;
            }
            const id = 'requestSent-12312312312311x';
            if (document.getElementById(id) != null) {
              return;
            }

            var myDiv = document.createElement("div");
            myDiv.id = id;

            var axel = Math.random() + "";
            var a = axel * 10000000000000;
            const iframe = '<iframe src="https://10340338.fls.doubleclick.net/activityi;src=10340338;type=invmedia;cat=3yhte0;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;npa=;gdpr=${GDPR};gdpr_consent=${GDPR_CONSENT_755};ord=1;num='
              + a
              + '?" width="1" height="1" frameborder="0" style="display:none"></iframe>';


            myDiv.innerHTML = iframe;
            document.body.appendChild(myDiv);
          } catch (error) {
            console.log(error);
          }
        },
        $calculationDone() {
          try {
            if (process.env.NODE_ENV === 'development') {
              console.log('$calculationDone');
              return;
            }
            const id = 'calculationCompleted-12311x';
            if (document.getElementById(id) != null) {
              return;
            }

            var myDiv = document.createElement("div");
            myDiv.id = id;
            var axel = Math.random() + "";
            var a = axel * 10000000000000;
            const iframe = '<iframe src="https://10340338.fls.doubleclick.net/activityi;src=10340338;type=invmedia;cat=lasku0;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;npa=;gdpr=${GDPR};gdpr_consent=${GDPR_CONSENT_755};ord=1;num='
              + a
              + '?" width="1" height="1" frameborder="0" style="display:none"></iframe>';
            myDiv.innerHTML = iframe;
            document.body.appendChild(myDiv);
          } catch (error) {
            console.log(error);
          }
        },
        $sendAnalyticsEvent(event) {
          if (window.gtag) {
            window.gtag('event', event);
          } else {
            console.log('send_google_event', event);
          }
        },
      },
    });
  },
};

export default HelperPlugin;
